
const articleData = [
    {
        id: 1,
        title: "Start with the WHY. Remember the HOW.",
        img: require("../images/articles/startWhyRememberHow.png"),
        link: "/start-with-the-why-remember-the-how"
    },
    {
        id: 2,
        title: "Start 2025 with a BANG!",
        img: require("../images/articles/Fireworks.png"),
        link: "/start-2025-with-a-bang"
    },
    {
        id: 3,
        title: "The power of your mindset: Unlocking your true potential for success",
        img: require("../images/articles/mindset.jpg"),
        link: "/the-power-of-your-mindset"
    }
]

export default articleData;